import React, { useState } from 'react';
import { useSwipeable } from 'react-swipeable';
import { content } from './content';
import './App.css';

function NavButton({ screenId, setActiveScreen, activeScreen, iconClass, svgIcon }) {
  return (
    <button
      className={`button is-flex is-flex-direction-column is-justify-content-center is-align-items-center is-fullheight ${activeScreen === screenId ? 'is-active' : ''}`}
      onClick={() => setActiveScreen(screenId)}
      style={{
        flex: 1,
        borderRadius: 0,
        border: 'none',
        backgroundColor: 'transparent'
      }}
    >
      <span className={`icon is-small ${activeScreen === screenId ? 'is-active' : ''}`}>
        {!svgIcon && <i className={iconClass}></i>}
        {svgIcon && activeScreen && <img src={`/img/icons/${svgIcon}${activeScreen === screenId ? '_on' : '_off'}.png`} 
        className={`${activeScreen === screenId ? '' : 'is-inactive'}`}
        alt={svgIcon} />}        
      </span>
    </button>
  );
}

function HomeScreen() {
  return (
    <div className="section is-flex is-align-items-center is-justify-content-center" style={{ minHeight: '100vh' }}>
      <div className="column">
        <div className="card-content has-text-centered">
          <h1><b>About the RASA Measurement Project</b></h1>
          <p>
            We measure to show it can be done, we’re the only ones who measure this way, and we measure the whole lifecycle of each barrel from cradle to recycle and beyond.
          </p>
          <button className="button  is-rounded">Contact Us</button>
        </div>
      </div>
    </div>
  );
}

function BarrelScreen() {
  const { owner, /*isConsumed,*/ referenceNumber, totalFuel, totalTbds, miningLocation, miningDate, processingLocation, processingDate } = content.page.barrel;
  return (
    <div className="section is-flex is-align-items-center is-justify-content-center" style={{ minHeight: '100vh' }}>      
      <div className="column">
        <div className="card-content has-text-centered">
        <div>
        <button className="button is-rounded logo"></button>
      </div>
      <br/>
          <p><b>This barrel belongs to</b>
            <h1><b>{owner}</b></h1></p>
          <p><b>ref </b>#{referenceNumber}</p>
        </div>

        <div className="card-image has-text-centered">
          <div className="barrel-hero" />
          <p><b>{totalTbds.value.toFixed(1)} TBDs were used to produce this barrel</b></p>
          <p><b>{totalFuel.value.toFixed(0)} {totalFuel.units} of fuel were used to produce this barrel</b></p>
          <p>Mined from {miningLocation}, {miningDate}</p>
          <p>Processed at {processingLocation}, {processingDate}</p>
        </div>
      </div>
    </div>
  );
}

function MiningScreen() {
  const { tbdsUsed, location, oreType, extractionDate, tonnage, equipmentId, personnel, fuel } = content.page.mining;
  return (
    <div className="section is-flex is-align-items-center is-justify-content-center">
      <div className="column">
        <div className="hero box mining-hero">
          <div className="hero-body">
            <div className="card-content has-text-centered">
              <p style={{ fontSize: 200, fontWeight: 900 }}>
                {tbdsUsed.value.toFixed(0)}
              </p>
              <h2>I’m copy that describes mining in more detail</h2>
              <br />
              <p>
                Nothing too heavy, just a bit more color on where the energy is used and how it is measured - where the sensors are and what they measure etc.
              </p>
            </div>
          </div>
        </div>
        <div className="column">
          <div className="card-image has-text-centered">
            <p><b>{tbdsUsed.value.toFixed(0)} TBDs were used to mine</b></p>
            <p>Mined at <b>{location}</b></p>
            <p><b>Ore of type {oreType} was mined</b></p>
            <p><b>Ore extracted on {extractionDate}</b></p>
            <p><b>{tonnage.value.toFixed(0)} {tonnage.units} were mined</b></p>
            <p><b>Mined using {equipmentId}</b></p>
            <p><b>Mining personnel: {personnel}</b></p>
            <p><b>{fuel.value.toFixed(0)} {fuel.units} were used to mine</b></p>
            <p>I’m copy that describes the process of mining / extracting - I am brief and to the point</p>
          </div>
        </div>
      </div>
    </div >
  );
}

function TransportScreen() {
  const { tbdsUsed, origin, destination, departureTime, arrivalTime, equipmentId, distance, ore, fuel } = content.page.transport;
  return (
    <div className="section is-flex is-align-items-center is-justify-content-center">
      <div className="column">
        <div className="hero box transport-hero">
          <div className="hero-body">
            <div className="card-image has-text-centered">
              <p style={{ fontSize: 200, fontWeight: 900 }}>
                {content.page.transport.tbdsUsed.value.toFixed(0)}
              </p>
            </div>
          </div>
        </div>
        <div className="column">
          <div className="card-image has-text-centered">
            <p><b>{tbdsUsed.value.toFixed(0)} TBDs were used to haul</b></p>
            <p><b>Transported from {origin} on {departureTime} to {destination} on {arrivalTime}</b></p>
            <p><b>Transported by {equipmentId} for {distance.value.toFixed(0)} {distance.units}</b></p>
            <p><b>{ore.value.toFixed(0)} {ore.units} of ore were hauled hauled {distance.value.toFixed(0)} {distance.units}</b></p>            
            <p><b>{fuel.value.toFixed(0)} {fuel.units} were consumed in hauling</b></p>
            <p>I’m copy that describes the process of hauling distance, weight etc. — I am brief and to the point</p>
          </div>
        </div>
      </div>
    </div>
  );
}

function CrushingScreen() {
  const { tbdsUsed, ore, crushedOre, fuel, efficiency, gradation, equipmentId} = content.page.crushing;
  return (
    <div className="section is-flex is-align-items-center is-justify-content-center">
      <div className="column">
        <div className="hero box crushing-hero">
          <div className="hero-body">
            <div className="card-image has-text-centered">
              <p style={{ fontSize: 200, fontWeight: 900 }}>
                {tbdsUsed.value.toFixed(0)}
              </p>
            </div>
          </div>
        </div>
        <div className="column">
          <div className="card-image has-text-centered">
            <p><b>{tbdsUsed.value.toFixed(0)} TBDs were used to crush</b></p>
            <p><b>{ore.value.toFixed(0)} {ore.units} of ore were crushed at {efficiency.value} {efficiency.units} by {equipmentId}</b></p>
            <p><b>{crushedOre.value.toFixed(0)} {crushedOre.units} of ore were produced at {gradation.value} {gradation.units} gradation</b></p>
            <p><b>{fuel.value.toFixed(0)} {fuel.units} of fuel were used to crush</b></p>
            <p>I’m copy that describes the process of crushing size in / size out maybe — I am brief and to the point</p>
          </div>
        </div>
      </div>
    </div>
  );
}

function PsaScreen() {
  const { crushedOre, diesel, bitumen, sand, fuel, tbdsUsed, aggregateWeight, aggregateWaterContent } = content.page.psa;
  return (
    <div className="section is-flex is-align-items-center is-justify-content-center">
      <div className="column">
        <div className="hero box psa-hero">
          <div className="hero-body">
            <div className="card-image has-text-centered">
              <p style={{ fontSize: 200, fontWeight: 900 }}>
                {tbdsUsed.value.toFixed(0)}
              </p>
            </div>
          </div>
        </div>
        <div className="column">
          <div className="card-image has-text-centered">
            <p><b>{tbdsUsed.value.toFixed(0)} TBDs were used to fractionate (process)</b></p>
            <p><b>{fuel.value.toFixed(0)} {fuel.units} of fuel were used</b></p>
            <p><b>{crushedOre.value.toFixed(0)} {crushedOre.units} of ore were used</b></p>
            <p><b>{diesel.value.toFixed(0)} {diesel.units} of diesel were produced</b></p>
            <p><b>{bitumen.value.toFixed(0)} {bitumen.units} of bitumen were produced</b></p>
            <p><b>{sand.value.toFixed(0)} {sand.units} of sand were produced</b></p>
            <p><b>Aggregate weight of {aggregateWeight.value.toFixed(0)} {aggregateWeight.units} of sand were processed with {aggregateWaterContent.value} {aggregateWaterContent.units} water content</b></p>              
            <p>I’m copy that describes what the PSA is and why it is magical — I am brief and to the point</p>
          </div>
        </div>
      </div>
    </div>
  );
}

function FractionateScreen() {
  const { tbdsUsed, title, outputs } = content.page.fractionate;
  return (
    <div className="section is-flex is-align-items-center is-justify-content-center">
      <div className="column">
        <div className="hero box">
          <div className="hero-body fractionate-hero">
            <div className="card-image has-text-centered">
              <p style={{ fontSize: 200, fontWeight: 900 }}>
                {title}
              </p>
            </div>
          </div>
        </div>
        <div className="column">
          <div className="card-image has-text-centered">
            <p><b>{tbdsUsed} TBDs were used to fractionate (process)</b></p>
            I’m copy that describes the process of fractionating
            <ul>
              {outputs.map((output, i) => {
                return (<li key={i}>
                  <ul>
                    <li>{output.percent}% of your barrel will be used for {output.description}</li>
                    <li>{output.sand.value.toFixed(0)} {output.sand.units} of sand of {output.sand.fitness} fitness produced</li>
                    <li>{output.asphaltenes.value.toFixed(0)} {output.asphaltenes.units} of asphaltenes of {output.asphaltenes.grade} grade produced</li>
                    <li>{output.maltenes.value.toFixed(0)} {output.maltenes.units} of maltenes of {output.maltenes.grade} grade produced</li>
                    <li>{output.resins.value.toFixed(0)} {output.resins.units} of resins of {output.resins.grade} grade produced</li>
                    <li>{output.aromatics.value.toFixed(0)} {output.aromatics.units} of aromatics of {output.aromatics.grade} grade produced</li>
                    <li>{output.saturates.value.toFixed(0)} {output.saturates.units} of saturates of {output.saturates.grade} grade produced</li>
                    <li>{output.waxContent.value.toFixed(0)} {output.waxContent.units} of wax content</li>
                    <li>{output.fuel.value.toFixed(0)} {output.fuel.units} used</li>
                  </ul>                  
                  </li>)
              })}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

function MobileLayout() {
  const [activeScreen, setActiveScreen] = useState('barrel');

  const screens = ['home', 'barrel', 'mining', 'transport', 'crushing', 'psa', 'fractionate'];

  const renderScreen = () => {
    switch (activeScreen) {
      case 'home':
        return <HomeScreen />;
      case 'barrel':
        return <BarrelScreen />;
      case 'mining':
        return <MiningScreen />;
      case 'transport':
        return <TransportScreen />;
      case 'crushing':
        return <CrushingScreen />;
      case 'psa':
        return <PsaScreen />;
      case 'fractionate':
        return <FractionateScreen />;
      default:
        return <BarrelScreen />;
    }
  };

  const handleSwipe = (direction) => {
    const currentIndex = screens.indexOf(activeScreen);
    if (direction === 'left' && currentIndex < screens.length - 1) {
      setActiveScreen(screens[currentIndex + 1]);
    } else if (direction === 'right' && currentIndex > 0) {
      setActiveScreen(screens[currentIndex - 1]);
    }
  };

  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => handleSwipe('left'),
    onSwipedRight: () => handleSwipe('right'),
  });

  return (
    <div className="container is-fluid px-0" style={{ minHeight: '100vh' }} {...swipeHandlers}>
      {/* Top Navigation Bar */}
      <div>
        <nav className="navbar navbar-top is-fixed-top is-link" >
          <div className="navbar-brand">
            <button className="navbar-item button is-link" onClick={() => setActiveScreen('home')}>
              <span className="icon is-small">
                <i className="fas fa-home"></i>
              </span>
            </button>
          </div>
        </nav>
      </div>

      {/* Main Content Area */}
      <main className="pb-6" style={{
        paddingBottom: 'var(--nav-height)',
        minHeight: 'calc(100vh - var(--nav-height))'
      }}>
        {renderScreen()}
      </main>

      {/* Bottom Navigation Bar */}
      <nav
        className="navbar is-fixed-bottom is-link"
        style={{
          height: 'var(--nav-height)',
          overflow: 'hidden'
        }}
      >
        <div className="navbar-menu is-active button-bar">
          <div className="navbar-item is-flex is-justify-content-space-around px-0"
            style={{ width: '100%', height: '100%' }}>
            <NavButton screenId="barrel" setActiveScreen={setActiveScreen} activeScreen={activeScreen} svgIcon="barrel_icon" />
            <NavButton screenId="mining" setActiveScreen={setActiveScreen} activeScreen={activeScreen} svgIcon="crusher_icon" />
            <NavButton screenId="transport" setActiveScreen={setActiveScreen} activeScreen={activeScreen} iconClass="fas fa-truck" />
            <NavButton screenId="crushing" setActiveScreen={setActiveScreen} activeScreen={activeScreen} iconClass="fas fa-hand-holding-droplet" />
            <NavButton screenId="psa" setActiveScreen={setActiveScreen} activeScreen={activeScreen} iconClass="fas fa-diagram-project" />
            <NavButton screenId="fractionate" setActiveScreen={setActiveScreen} activeScreen={activeScreen} iconClass="fas fa-chart-pie" />
          </div>
        </div>
      </nav>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <MobileLayout />
      </header>
    </div>
  );
}

export default App;